/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneQuotebox as ResolvedStandaloneQuotebox } from 'base/components/standalone/Quotebox';

export const Quotebox: typeof ResolvedStandaloneQuotebox = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneQuotebox {...props} />
        </ErrorBoundary>
    );
});

export type QuoteboxProps = PropsFromComponent<typeof Quotebox>;

/** @deprecated Use slot architecture instead */
export const QuoteboxWith = (extras: DynamicStandaloneExtras): typeof Quotebox => {
    return function Quotebox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Quotebox');
        return <ResolvedStandaloneQuotebox {...mergeProps({ options: { theme } }, props)} />;
    }
}